// Collects the per-kind attribute blocks into the shape generateTagName
// wants, so ItemDetail stays under the 400-line guard. Only one block
// drives the formula at a time — the dispatcher logic lives in
// packages/domain's resolveKindUsed().

import type { TagNameInput } from "@betterpos/domain";
import type {
  AmmoAttributes,
  FirearmAttributes,
  HolsterAttributes,
  OpticsAttributes,
} from "../../data/catalog.ts";

export function buildTagNameInputs(args: {
  kind: string;
  displayName: string;
  firearm: FirearmAttributes | null;
  ammo: AmmoAttributes | null;
  optics: OpticsAttributes | null;
  holster: HolsterAttributes | null;
}): Omit<TagNameInput, "override"> {
  return {
    kind: args.kind,
    displayName: args.displayName,
    firearm: args.firearm
      ? {
          manufacturer: args.firearm.manufacturer,
          model: args.firearm.model,
          caliberGauge: args.firearm.caliberGauge,
          barrelLengthIn: args.firearm.barrelLengthIn,
          finish: args.firearm.finish,
          features: args.firearm.features ?? [],
          magazineCapacity: args.firearm.magazineCapacity,
        }
      : null,
    ammo: args.ammo
      ? {
          manufacturer: args.ammo.manufacturer,
          caliberGauge: args.ammo.caliberGauge,
          grain: args.ammo.grain,
          bulletType: args.ammo.bulletType,
          roundsPerBox: args.ammo.roundsPerBox,
        }
      : null,
    optics: args.optics
      ? {
          manufacturer: args.optics.manufacturer,
          model: args.optics.model,
          magnification: args.optics.magnification,
          reticle: args.optics.reticle,
        }
      : null,
    holster: args.holster
      ? {
          manufacturer: args.holster.manufacturer,
          fitModel: args.holster.fitModel,
          mountType: args.holster.mountType,
          drawSide: args.holster.drawSide,
        }
      : null,
  };
}
